/* eslint-disable */

/**
 * SameSite allows a server to define a cookie attribute making it impossible for the
 * browser to send this cookie along with cross-site requests. The main goal is to mitigate
 * the risk of cross-origin information leakage, and provide some protection against
 * cross-site request forgery attacks.
 */
export enum EnumSameSite {
  DEFAULT_MODE = "DEFAULT_MODE",
  LAX_MODE = "LAX_MODE",
  STRICT_MODE = "STRICT_MODE",
  NONE_MODE = "NONE_MODE",
}

/** An HTTP or email header. */
export interface Header {
  name?: string;
  value?: string;
}

/** A set of HTTP or email headers. */
export interface Headers {
  header?: Header[];
}

/** A cookie, fields as specified by RFC2109. */
export interface Cookie {
  name?: string;
  value?: string;
  domain?: string;
  comment?: string;
  max_age?: number;
  secure?: boolean;
  version?: number;
  is_http_only?: boolean;
  /** Supported only in the Go Service Container for now * */
  path?: string;
  /** See https://tools.ietf.org/html/draft-ietf-httpbis-cookie-same-site-00. Supported only in the Go Service Container for now * */
  same_site?: EnumSameSite;
}

/** A set of cookies. */
export interface Cookies {
  cookie?: Cookie[];
}
